import { Component, Output, EventEmitter, Input } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { IAppState } from "../../store/state/app.state";
import { selectUserLogged } from "../../store/selectors/user.selector";
import { Subscription } from "rxjs";
import { EButtonType } from "../../data-types/button.enum";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { iconsLibrary } from "../../../theme/constants";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../services/local-storage.service";
import { EStorageType } from "../../data-types/storage.enum";
@Component({
  selector: "cowing-core-landing",
  templateUrl: "./landing.component.html",
  styleUrls: ["./landing.component.scss"],
})
export class LandingComponent {
  @Input('isMobile') isMobile = false;
  @Output('onRegister') onRegister = new EventEmitter();
  public toggleLoginMenu = false;
  public toggleCompanyCoworkingMenu = false;
  public isInLogin = false;
  public isPwdRecov = false;
  public EButtonType = EButtonType;
  public token: string = "";
  public recoverEmail: string = "";
  public EStorageType = EStorageType;
  constructor(
    private _store: Store<IAppState>,
    private router: Router,
    private route: ActivatedRoute,
    private localStorage: LocalStorageService,
    public translate: TranslateService
  ) {
    router.events.subscribe((val) => {
      // see also

      if (val instanceof NavigationEnd) {
        const url = val.url.split("?")[0];
        // OR WE CAN USE A .FIND OR INDEXOF
        if (url === "/login") {
          this.isInLogin = true;
        } else if (url === "/pwd-recovery") {
          const queryParams = route.snapshot.queryParams;
          // const parts = val.url.split("?")[1].split("&");
          this.recoverEmail = queryParams.email;
          this.token = queryParams.token;
          this.isInLogin = false;
          this.isPwdRecov = true;
        } else {
          this.isInLogin = false;
        }
      }
    });
  }
  ngOnInit() {
    this.localStorage.set(EStorageType.Language, this.translate.defaultLang);
  }
  public changeLang(lang) {
    this.translate.use(lang);
    this.localStorage.set(EStorageType.Language, lang);
  }

  get isActiveLang() {
    return this.translate.currentLang
      ? this.translate.currentLang
      : this.translate.defaultLang;
  }
  toggleClickBack() {
    this.isInLogin
      ? this.router.navigate(["landing"])
      : (this.toggleLoginMenu = !this.toggleLoginMenu);
  }
  toCoworkingRegister($event) {
    this.router.navigate(["coworking-register"]);
  }

  toCompanyCoworkingRegister($event) {
    this.router.navigate(["company-plus-register"]);
  }

  toggleCompanyCoworkingRegister($event) {
    this.toggleCompanyCoworkingMenu= true;
  }

  toCompanyRegister($event) {
    this.router.navigate(["company-register"]);
  }

  toLogin(event) {
    // console.log(event);
    this.router.navigate(["login"]);
    // this.toggleLoginMenu = true;
  }

  toggleRegisterMenu(event) {
    if (this.isMobile) {
      this.onRegister.emit('https://www.cowing.es/')
    } else {
      this.toggleLoginMenu = true;
    }
  }

  public get getBackIcon() {
    return `${iconsLibrary.arrowLeft}`;
  }

  public get getLogoImage() {
    return `${iconsLibrary.logoMini}`;
  }

  public get getLandingImage() {
    return `${iconsLibrary.landingImage}`;
  }

  public get getLandingImageMobile() {
    return `${iconsLibrary.mobileLanding}`;
  }

  ngOnDestroy() {
    // this.subscriber.unsubscribe();
  }
}
